import * as React from 'react'

export type TooltipBoundaryContextType = React.RefObject<HTMLElement> | null

export const TooltipBoundaryContext =
  React.createContext<TooltipBoundaryContextType>(null)

export const useTooltipBoundary = () =>
  React.useContext(TooltipBoundaryContext)
